import {RootState} from '../rootReducer';

export const userListSelector = (state: RootState) => state.user.list;

export const externalUserListSelector = (state: RootState) => state.user.externalList;
